(ns ycweb.app.website.myaccount.aftersales.clientorders
  (:require
   [rum.core :as rum]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.date :as ud]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc aftersales-selection-line < rum/reactive [app-atom case-type client-order]
  (let [{:client-order/keys
         [date-placed total-price receiver-name contact-name]
         :ent/keys [display-name]} client-order
        registry-order-id (:client-order/for-registry-order-id client-order)
        client-order-uuid (:ent/uuid client-order)]
    [:tr.yc-tr
     [:th.yc-th {:scope "row" :data-th "Order No."} display-name]
     [:td.yc-td
      [:span.yc-td__faux-table {:data-th "Date"}
       [:span.yc-td__faux-td
        [:span.clip-date.unclip-date--t.clip-date--ma.unclip-date--l {:data-date (ud/date-format (ud/coerce-date date-placed) "dd/MM/YYYY")}
         [:span.clip-date__text (ud/date-format (ud/coerce-date date-placed) "dd MMM YYYY")]]]]]
     [:td.yc-td
      [:span.yc-td__faux-table {:data-th "Shipped To"}
       [:span.yc-td__faux-td
        (cond
          (not (= "" receiver-name))
          receiver-name

          registry-order-id
          "Registry Recipient"

          :else
          contact-name)]]]
     [:td.yc-td
      [:span.yc-td__faux-table {:data-th "Amount"}
       [:span.yc-td__faux-td
        "R" (u/currency-format total-price)]]]
     [:td.yc-td.yc-td--centered
      [:span.yc-td__faux-table {:data-th "Options"}
       [:span.yc-td__faux-td
        [:a.text-link
         (urlstate/href-props app-atom "myaccount" "aftersalecreate" {:uuid client-order-uuid :casetype (name case-type)})
         "Choose"]]]]]))

(rum/defc aftersales-selection-table < rum/reactive [app-atom case-type client-orders]
  [:table.yc-table
   [:caption.yc-table-caption.hidden-from-view
    "View your most recent orders"]
   [:colgroup
    [:col]
    [:col]
    [:col]
    [:col]
    [:col]]
   [:thead.yc-thead
    [:tr.yc-tr
     [:th.yc-th {:scope "col"}
      "Order"
      [:span.clip-text.unclip-text--l " No."]]
     [:th.yc-th {:scope "col"}
      "Date"
      [:span.clip-text.unclip-text--l " Placed"]]
     [:th.yc-th {:scope "col"}
      "Shipped"
      [:span.clip-text.unclip-text--l " To"]]
     [:th.yc-th {:scope "col"}
      "Amount"]
     [:th.yc-th.yc-th--centered
      "Options"]]]

   ;; TODO: pagination
   (into
     [:tbody.yc-tbody]
     (map (partial aftersales-selection-line app-atom case-type) client-orders))])

(defn repair-intro []
  [:div
   (headings/heading "Arrange a Repair" {:type :h2 :size :medium})
   [:p.yc-paragraph.u-max-width-720
    "Find and select the corresponding order for the item that needs repairing below."
    [:br]
    [:b "Please note: "]
    "Products outside of their warranty period, will require shipping and repair costs."
    [:br]
    [:a.text-link.js-mfp-open-url
     {:href "/help.htm?action=article&id=155"
      :target_url "/help.htm?action=article&id=155&overrideincludes=blank"
      :data-title "Returns & Repairs Policy"
      :data-content-wrapper-class "yc-simple-text"}
     "View costs and warranty info."]]])

(defn return-intro []
  [:div
   (headings/heading "Arrange a Return or Exchange" {:type :h2 :size :medium})
   [:p.yc-paragraph.u-max-width-720
    [:b "We allow free returns on items purchased in the last 30 days. "]
    "Returns and exchanges on items purchased more than 30 days ago might incur "
    [:a.text-link.js-mfp-open-url
     {:href "/help.htm?action=article&id=155"
      :target_url "/help.htm?action=article&id=155&overrideincludes=blank"
      :data-title "Returns & Repairs Policy"
      :data-content-wrapper-class "yc-simple-text"}
     "shipping and processing fees"]
    ". All returns and exchanges are subject to "
    [:a.text-link.js-mfp-open-url
     {:href "/help.htm?action=article&id=155"
      :target_url "/help.htm?action=article&id=155&overrideincludes=blank"
      :data-title "Returns & Repairs Policy"
      :data-content-wrapper-class "yc-simple-text"}
     "terms and conditions"] "."]])

(rum/defc aftersales-clientorders < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)

        client-orders (cmn/curact process-atom [:client-orders])
        old-orders (cmn/curact process-atom [:old-client-orders])
        show-old-orders? (cmn/curact process-atom [:show-old-orders?])
        case-type (cmn/curact process-atom [:aftersale/type])]

    (cond
      (and (> (count client-orders) 0) (empty? old-orders))
      [:div.dashboard
       (case case-type
         :return
         (return-intro)
         :repair
         (repair-intro))

       (when (> (count client-orders) 0)
         (aftersales-selection-table app-atom case-type client-orders))

       (toaster/loading-overlay app-atom :web.myaccount/client-order-list)]

      (and (> (count client-orders) 0) (> (count old-orders) 0))
      [:div.dashboard
       (case case-type
         :return
         (return-intro)
         :repair
         (repair-intro))

       (when (> (count client-orders) 0)
         (aftersales-selection-table app-atom case-type client-orders))

       (when (and client-orders (> (count client-orders) 0) old-orders (> (count old-orders) 0))
         [:div.dashboard-footer.button-group
          (buttons/button-web (str (if show-old-orders? "Hide" "Show") " orders older than 30 days")
            {:on-click
             #(swap! process-atom assoc-in [:show-old-orders?] (not show-old-orders?))
             :type :button
             :style :light
             :size :small})])

       (when (and old-orders (> (count old-orders) 0))
         [:div
          (when-not show-old-orders? {:class ["u-hide-block"]})
          (headings/heading "Orders older than 30 days" {:type :h3 :size :small :icon :error :class "text-status--important"})
          (aftersales-selection-table app-atom case-type old-orders)])

       (toaster/loading-overlay app-atom :web.myaccount/client-order-list)]

      (and (empty? client-orders) (> (count old-orders) 0))
      [:div.dashboard
       (case case-type
         :return
         (return-intro)
         :repair
         (repair-intro))


       (when (and old-orders (> (count old-orders) 0))
         [:div
          (headings/heading "Orders older than 30 days" {:type :h3 :size :small :icon :error :class "text-status--important"})
          (aftersales-selection-table app-atom case-type old-orders)])

       (toaster/loading-overlay app-atom :web.myaccount/client-order-list)]

      :else
      [:div.no-data-wrapper.yc-section.yc-section--standard
       [:div.no-data-view
        [:p "You don't have any past orders."]
        [:div.button-wrapper.button-wrapper--align-center
         (buttons/button-web "Start shopping"
           {:href "/index.htm"
            :style :dark})]]
       (toaster/loading-overlay app-atom :web.myaccount/client-order-list)])))

(defmethod comms/receive :web.myaccount/aftersales-clientorders [app-atom e]
  (toaster/close-overlay app-atom :web.myaccount/client-order-list)
  (swap! (cmn/process-cursor app-atom) assoc
    :client-orders (:client-orders e)
    :old-client-orders (:old-client-orders e)))

;Repairs----------------------------------------------

(defmethod flow/render-screen :web.myaccount/createrepair [app-atom _]
  (awm.common/screen-wrapper app-atom
    (aftersales-clientorders app-atom)))

(defmethod t/transition-open :web.myaccount/createrepair [app-atom _ _]
  (swap! (cmn/process-cursor app-atom) assoc :aftersale/type :repair)
  (toaster/open-overlay app-atom :web.myaccount/client-order-list)
  (comms/ajax-get :web.myaccount/aftersales-clientorders {:case-type :repair}))

;Returns----------------------------------------------

(defmethod flow/render-screen :web.myaccount/createreturn [app-atom _]
  (awm.common/screen-wrapper app-atom
    (aftersales-clientorders app-atom)))

(defmethod t/transition-open :web.myaccount/createreturn [app-atom _ _]
  (swap! (cmn/process-cursor app-atom) assoc :aftersale/type  :return)
  (toaster/open-overlay app-atom :web.myaccount/client-order-list)
  (comms/ajax-get :web.myaccount/aftersales-clientorders {:case-type :return}))